import Util from '../../forecast-app/shared/util/util';
import UpdateInitialPlanProjectMutation from '../../mutations/UpdateInitialPlanProjectMutation';

export const changeBaselineWinChance = (winChance: number | null, projectId: string, onSuccess?: () => void): void => {
	Util.CommitMutation(
		UpdateInitialPlanProjectMutation,
		{
			id: projectId,
			baselineWinChance: winChance,
		},
		onSuccess
	);
};
